// extracted by mini-css-extract-plugin
export default {"illustration":"n6v1uteU5AA_71X7qZ8Q"};